module.exports = __webpack_public_path__ + "static/media/01-start.c107ed7a.png";